import { Model } from 'dva'
import { TelephonyService } from '../../../Service'
import { IsObject } from '../../../Utils/helpers'
import { FailureHandler } from 'Utils/ApiHelper'
import { Client } from './types'

const Clients: Model = {
  namespace: 'clients',
  state: {
    list: [],
  },
  effects: {
    *list(
      { useCache = true, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let clients = yield select((state: any) => state.clients.list)
        if (!(clients.length > 0 && useCache)) {
          clients = yield call(TelephonyService.telephonyClientsList, {})
          yield put({ type: 'modifyList', payload: clients })
        }
        onSuccess(clients)
      } catch (err: any) {
        FailureHandler('Error fetching clients', err, onFailure)
      }
      setLoading(false)
    },
    *retrieve(
      { id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let client = yield select((state: any) =>
          state.clients.list.find((client: Client) => client.id === id)
        )
        if (!client) {
          client = yield call(TelephonyService.telephonyClientsRetrieve, { id: id })
        }
        yield put({ type: 'modifyList', payload: client })
        onSuccess(client)
      } catch (err) {
        FailureHandler('Could not find the client!', err, onFailure)
      }
      setLoading(false)
    },
    *create(
      { data = {}, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(TelephonyService.telephonyClientsCreate, { requestBody: data })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error adding a client', err, onFailure)
      }
      setLoading(false)
    },
    *partialUpdate(
      { id, data, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(TelephonyService.telephonyClientsPartialUpdate, {
          id: id,
          requestBody: data,
        })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error editing a client', err, onFailure)
      }
      setLoading(false)
    },
    *destroy(
      { id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        yield call(TelephonyService.telephonyClientsDestroy, { id: id })
        yield put({ type: 'modifyList', payload: id })
        onSuccess()
      } catch (err) {
        FailureHandler('Error deleting a client', err, onFailure)
      }
      setLoading(false)
    },
  },
  reducers: {
    modifyList(state, action) {
      // clone the list
      let list = [...state.list]
      if (IsObject(action.payload)) {
        // if the payload is an object, it's a single object, so add it to the list
        list = list.filter((l: Client) => l.id !== action.payload.id)
        list.push(action.payload)
      } else if (Array.isArray(action.payload)) {
        // if the payload is an array, it's a list of objects, so add them to the list
        list = list
          .filter((l: Client) => !action.payload.map((p: Client) => p.id).includes(l.id))
          .concat(action.payload)
      } else if (Number.isInteger(action.payload)) {
        // if the payload is an integer, it's an id sent in delete operations, so remove it from the list
        list = list.filter((l: Client) => l.id !== action.payload)
      }
      return {
        ...state,
        list: list,
      }
    },
    resetClients(state, action) {
      return {
        ...state,
        list: [],
      }
    },
  },
}

export default Clients
